module.exports = __webpack_public_path__ + "static/stephen-d51da98b4a45bfe82bac5c9a00fc2e19.jpg";